import ReadOnlyTable from "./ReadOnlyTable";

const ModelGroupingTable = ({ data = [], showRating = false }) => {
  const columns = [
    { key: "brandName", header: "Brand Name", render: (r) => r.brandName || "N/A" },
    { key: "modelName", header: "Model Name", render: (r) => r.modelName || "N/A" },
    showRating && { key: "rating", header: "Rating", render: (r) => r.rating ?? "-" },
    { key: "applicationNumber", header: "Cert Number", render: (r) => r.applicationNumber || "-" },
    { key: "certPrefix", header: "Cert Suffix", render: (r) => (Number(r.certPrefix) ? r.certPrefix : "-") },
  ];

  return (
    <>
      <div className="table-title mt-2">
        <h3>Model Grouping</h3>
      </div>
      <ReadOnlyTable columns={columns} rows={data} rowKey={(r) => r.sgbpProductId} />
    </>
  );
};

export default ModelGroupingTable;